import { View, Text, Pressable } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { useRouter } from 'expo-router';
import Unicon from '@/components/General/Unicon';
import FeatureIcon, { getRouteFeature } from '@/components/General/FeatureIcon';
import DropdownMenu from '@/components/General/DropdownMenu';
import { dropdownIcons } from '@/components/General/DropdownMenu';

const MODULE_FEATURES = {
  'People': 'people',
  'Events': 'events',
  'Tasks': 'tasks',
  'Roles': 'roles',
  'Training': 'training',
  'Automations': 'paths',
  'Paths': 'paths', // legacy stored module name
  'Small Groups': 'groups',
  'Connect': 'connect',
  'Forms': 'forms',
};

const RecentVisitCard = ({ item, onRemove, onAddToShortcuts }) => {
  const router = useRouter();
  const feature = item.type === 'file'
    ? 'files'
    : MODULE_FEATURES[item.module] || getRouteFeature(item.url) || 'dashboard';

  const menuOptions = [
    {
      name: 'Save to Shortcuts',
      icon: dropdownIcons.favorite,
      onSelect: onAddToShortcuts,
    },
    {
      name: 'Remove from Recents',
      icon: dropdownIcons.delete,
      onSelect: onRemove,
    },
  ];

  return (
    <Pressable
      style={styles.container}
      onPress={() => router.push({ pathname: item.url, params: item.params })}
    >
      <View style={styles.cardContent}>
        <FeatureIcon feature={feature} size={36} iconSize={18} testID={`RecentVisitCard-icon-${item.id}`} />
        <View style={styles.textContainer}>
          <Text style={styles.title} numberOfLines={1}>{item.title}</Text>
          <Text style={styles.subtitle} numberOfLines={1}>
            {item.subtitle ? `${item.module} · ${item.subtitle}` : item.module}
          </Text>
        </View>
        <DropdownMenu
          options={menuOptions}
          triggerComponent={
            <Pressable style={styles.menuButton}>
              <Unicon name="ellipsis-vertical" size={16} colorVariant="textSecondary" />
            </Pressable>
          }
        />
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create(({ colors, fonts, spacing, typography }) => ({
  container: {
    backgroundColor: 'transparent',
    borderRadius: 10,
    marginBottom: spacing.xs,
    paddingVertical: spacing.sm + 2,
    paddingHorizontal: spacing.sm,
    borderWidth: 0,
    _web: {
      transition: "all 0.15s ease",
      cursor: "pointer",
      _hover: { backgroundColor: colors.hover },
    },
  },
  cardContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
  },
  textContainer: {
    flex: 1,
  },
  title: {
    fontSize: typography.body,
    fontFamily: fonts.body,
    color: colors.text,
    marginBottom: 2,
  },
  subtitle: {
    fontSize: typography.caption,
    fontFamily: fonts.body,
    color: colors.textSecondary,
  },
  menuButton: {
    padding: spacing.xs,
    borderRadius: 8,
    _web: {
      transition: "background-color 0.15s ease",
      _hover: { backgroundColor: colors.hoverStrong },
    },
  },
}));

export default RecentVisitCard;
